
import React from "react";
import {
  Navigate,
} from "react-router-dom";


const DatasStampsList = React.lazy(() => import("../../../../../components/stamps/components/list/page"));


export const datasStampsRoutes = [
  {
    path: 'list',
    element: <DatasStampsList />,
  },
  {
    path: '',
    element: <Navigate replace to="/datas/stamps/list" />
  },
];